import type { Language } from '@offer-catalog/services/i18n'
import type { Universes } from '@/types/treeViewTypes'
import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { getUniverses } from '@/api'
import { queryKeys } from '@/query/queryKeys'

export function useUniverses(season: string) {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language.split('-')[0] as Language

  const { data, isError, isLoading, isSuccess } = useQuery({
    queryKey: queryKeys.universes(season),
    queryFn: async ({ signal }) => {
      if (!signal?.aborted) {
        return await getUniverses<Universes>(season)
      }
    },
  })

  const universes = data?.sort((a, b) => a.labels[currentLanguage].localeCompare(b.labels[currentLanguage]))
  return { universes, isError, isLoading, isSuccess }
}
